import api from "../../api";

const state = {
  status: "",
  list: [],
  list_interaction_code: []
};

const getters = {
  status: (state) => state.status,
  list: (state) => state.list,
  list_interaction_code_to_select: (state) => {
    let b = [];
    state.list_interaction_code.forEach((item) => {
      b.push({
        label: item.InteractionTemplateDescription,
        value: item.InteractionTemplateCode,
        IsEnabled: item.IsEnabled ?? true
      });
    });
    return b;
  },
  list_interaction_code: (state) => state.list_interaction_code
};

const actions = {
  create: ({ commit }, interaction) => {
    return new Promise((resolve, reject) => {
      commit("loading");
      //   commit("setSplashScreen", true, { root: true });

      api
        .post("/api/interactions", interaction)
        .then((resp) => {
          commit("success");
          resolve(resp);
        })
        .catch((error) => {
          commit("error");
          reject(error);
        });
    });
  },
  all: ({ commit, rootState }) => {
    return new Promise((resolve, reject) => {
      commit("loading");

      // const { page = 1, limit = 999 } = payload;

      api
        .get("/api/interactions", {
          timeout: 25000,
          params: {
            "criteria.interactionTemplateCode": "LLAMADA_V",
            "criteria.companyId": rootState.user.user.CompanySelected,
            "criteria.page": 1,
            "criteria.limit": 999,
            "criteria.skip": 0
          }
        })
        .then((resp) => {
          commit("success");
          commit("list", resp.data.Items);
          resolve(resp);
        })
        .catch((err) => {
          commit("error");
          reject(err);
        });
    });
  },
  get_interaction_code: ({ commit, rootState }) => {
    return new Promise((resolve, reject) => {
      commit("loading");

      // const { page = 1, limit = 999 } = payload;

      api
        .get("/api/interactions/getInteractionCode", {
          params: {
            "criteria.companyId": rootState.user.user.CompanySelected,
            "criteria.page": 1,
            "criteria.limit": 999
          }
        })
        .then((resp) => {
          commit("success");
          commit("list_interaction_code", resp.data.Items);
          resolve(resp);
        })
        .catch((err) => {
          commit("error");
          reject(err);
        });
    });
  }
};

const mutations = {
  loading: (state) => {
    state.status = "loading";
  },
  success: (state) => {
    state.status = "success";
  },
  list: (state, data) => {
    state.list = data;
  },
  error: (state) => {
    state.status = "error";
  },
  list_interaction_code: (state, data) => {
    state.list_interaction_code = data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
